import {Skeleton} from '@ds/components';

const ApplyDiscountListItemSkeleton: React.FC = () => {
  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-12 items-center justify-center">
        <Skeleton.Button active size="small" className="size-5" />
      </div>
      <div className="flex w-full flex-col gap-2 border-b border-gray-22 py-2 pe-4">
        <div className="flex items-center justify-between">
          <Skeleton active paragraph={{rows: 0}} title={{width: '70%'}} />
          <Skeleton.Button active size="small" className="size-6" />
        </div>
        <div className="flex items-start justify-between">
          <Skeleton.Button active size="small" className="h-5 w-15" />
          <Skeleton.Button active size="small" className="h-5 w-12.5" />
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Skeleton.Button active size="small" className="h-4 w-20" />
            <Skeleton.Button active size="small" className="h-5 w-10" />
            <Skeleton.Button active size="small" className="h-4 w-18" />
          </div>
          <Skeleton.Button active size="small" className="size-6" />
        </div>
      </div>
    </div>
  );
};

export default ApplyDiscountListItemSkeleton;
